import * as React from 'react';
import {
    a,
    useLocation
} from "react-router-dom";

import { useAuth } from '../../../Auth';

import './MainMenu.scss';
import '../../../Assets/Dripicons/webfont/webfont.css';

import { Button } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useEffect, useState } from 'react';
import { findMenuAuth } from '../OrgRoles/OrgRoles';
import { useHistory } from "react-router-dom";

function MainMenu(props) {
    const auth = useAuth();
    const t = useTranslate();
    const location = useLocation();
    const history = useHistory();

    const [username, setUsername] = useState("");
    const [menuopen, setMenuopen] = useState(false);
    const [menuAuth, setMenuAuth] = useState({});

    function logout() {
        auth.signout();
        window.location.href = "/login";
    }

    function handleHistoryPush(param){ 
        let editedItems = localStorage.getItem("editedItems");
        if(editedItems != undefined && editedItems == "true"){
            if(window.confirm(t("general.unsavedelements"))) { 
                localStorage.removeItem("editedItems");
                history.push(param);
            } else { 
                return false;
            };
        } else {
            history.push(param);
        };

    }

    useEffect(() => {
        if (localStorage.getItem("user") != null && JSON.parse(localStorage.getItem("user") as string)["userdata"]["unit"][0] != "") {
            const localStorageUser = JSON.parse(localStorage.getItem("user") as string);
            setUsername(localStorageUser["userdata"]["name"]);
            const isAdmin = localStorageUser["userdata"]["role"][0] == "Admin" ? true : false;
            try {
                setMenuAuth(findMenuAuth(localStorageUser["userdata"]["orgRole"][0], isAdmin));
            } catch (error) {
                auth.signout();
            }
        } else {
            auth.signout();
        }
    }, [localStorage.getItem("user")]);

    return (
        auth.user != undefined && auth.user["id"] && auth.user["userdata"]["unit"][0] != "" ? (
            <div className={menuopen ? "menu openmenu no-print" : "menu closedmenu no-print"}>
                <div className="menutoggle">
                    <i onClick={() => setMenuopen(!menuopen)} className={"dripicons-arrow-thin-left" + (menuopen ? " shown" : " hidden")}></i>
                    <i onClick={() => setMenuopen(!menuopen)} className={"dripicons-menu" + (menuopen ? " hidden" : " shown")}></i>
                </div>
                <div className="logo">
                    <img src={"https://via.placeholder.com/180x80"} alt="" />
                </div>
                <div className="username">
                    <p><span>{t("main_menu.welcomemessage")}</span><br />{username}</p>
                </div>
                <div className="menuitems">
                    <ul>
                        {/* <li data-satarget="menudashboard" data-safixed="true">
                            <a onClick={}"/"><i className="dripicons-meter" /><span>{t("main_menu.dashboard")}</span></a>
                        </li> */}

                        {menuAuth["resourcebooking"] ?
                            <li className={location.pathname == "/resourcebooking" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/resourcebooking")}><i className="dripicons-list" /><span>{t("main_menu.resourcebooking")}</span></a>
                            </li> : null}
                        {menuAuth["bookings"] ?
                            <li className={location.pathname == "/bookings" || location.pathname.includes("/booking") ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/bookings")}><i className="dripicons-user" /><span>{t("main_menu.bookings")}</span></a>
                            </li> : null}
                        {menuAuth["maintenance"] ?
                            <li className={location.pathname == "/maintenance" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/maintenance")}><i className="dripicons-brush" /><span>{t("main_menu.maintenance")}</span></a>
                            </li> : null}
                        {menuAuth["events"] ?
                            <li className={location.pathname == "/events" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/events")}><i className="dripicons-list" /><span>{t("main_menu.events")}</span></a>
                            </li> : null}
                        {menuAuth["persons"] ?
                            <li className={location.pathname == "/persons" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/persons")}><i className="dripicons-user" /><span>{t("main_menu.persons")}</span></a>
                            </li> : null}
                        {menuAuth["resources"] ?
                            <li className={location.pathname == "/resources" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/resources")}><i className="dripicons-document" /><span>{t("main_menu.resources")}</span></a>
                            </li> : null}
                        {menuAuth["customers"] ?
                            <li className={location.pathname == "/customers" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/customers")}><i className="dripicons-user-id" /><span>{t("main_menu.customers")}</span></a>
                            </li> : null}

                        <hr />
                        {menuAuth["myAccount"] ?
                            <li className={location.pathname == "/myaccount" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/myaccount")}><i className="dripicons-user" /><span>{t("main_menu.myaccount")}</span></a>
                            </li> : null}
                        {menuAuth["users"] ?
                            <li className={location.pathname == "/users" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/users")}><i className="dripicons-user-group" /><span>{t("main_menu.users")}</span></a>
                            </li>
                            : null}
                        {menuAuth["settings"] ?
                            <li className={location.pathname == "/settings" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/settings")}><i className="dripicons-gear" /><span>{t("main_menu.settings")}</span></a>
                            </li>
                            : null}
                        {menuAuth["eventExternal"] ?
                            <li className={location.pathname == "/eventexternal" ? "active" : ""}>
                                <a onClick={() => handleHistoryPush("/eventexternal")}><i className="dripicons-gear" /><span>{t("main_menu.events")}</span></a>
                            </li>
                            : null}
                    </ul>
                    <Button className="logoutBtn largescreen" onClick={logout}>{t("main_menu.logout")}</Button>
                    <Button className="logoutBtn smallscreen" onClick={logout}><i className="dripicons-exit"></i></Button>
                </div>
            </div>
        ) :
            (
                <div></div>
            )
    );
}

export default MainMenu;